export default __webpack_public_path__ + "static/prompt-f6ea44925fb294e0dbe724a130823fd6.mp4";